import React, { useState } from 'react';
import logo from "../images/icons/logo.svg"
import { Link } from 'react-router-dom';

function Header(props) {
    const [isMenu, setIsMenu] = useState(0)
    return (
        <div className='border-b-[1px]  p-5 px-5 lg:px-20'>
        <div className='flex flex-row justify-between items-center'>
            <a href='/'><img src={logo} /></a>
            <div className='hidden lg:flex'>
                <ul className='flex flex-col lg:flex-row lg:space-x-4'>
                    <li><Link to='/'>Home</Link></li>
                    <li><Link to='/about'>About</Link></li>
                    <li><Link to='/pricing'>Pricing</Link></li>
                    <li><Link to='/faqs'>FAQs</Link></li>
                    <li><Link to='/contact'>Contact</Link></li>
                    <li><Link to='/blogs'>Blogs</Link></li>
                </ul>
            </div>
            <div className=' hidden lg:flex flex-row space-x-4 items-center'>
                <span><a href='https://portal.yebokenny.com'>Login</a></span>
                <a href='https://portal.yebokenny.com/register' className='rounded-[30px] bg-[#008B39] text-white h-[47px] px-7 grid'>
                    <span className='my-auto'>Sign Up</span>
                </a>
                {/* <span><a href='https://yeboportal.web.app'>Login</a></span>
                <a href='https://yeboportal.web.app/register' className='rounded-[30px] bg-[#008B39] text-white h-[47px] px-7 grid'>
                    <span className='my-auto'>Sign Up</span>
                </a> */}
            </div>
            <div onClick={() => setIsMenu(!isMenu)} className='lg:hidden flex flex-col text-black bg-[#008B39] p-2 items-center grid space-y-[1px] hover:bg-[#0C6F35] cursor-pointer'>
                <hr className='h-1 w-4 my-auto'/>
                <hr className='h-1 w-4 my-auto'/>
                <hr className='h-1 w-4 my-auto'/>
            </div>
        </div>
        {isMenu ?
        <div className='lg:hidden'>
            <div>
                <ul className='flex flex-col space-y-1'>
                    <li><Link to='/'>Home</Link></li>
                    <li><Link to='/about'>About</Link></li>
                    <li><Link to='/pricing'>Pricing</Link></li>
                    <li><Link to='/faqs'>FAQs</Link></li>
                    <li><Link to='/contact'>Contact</Link></li>
                </ul>
            </div>
            <div className='flex flex-col items-center mt-2 space-y-2'>
                <a href='https://portal.yebokenny.com'>Login</a>
                <a href='https://portal.yebokenny.com/register' className='rounded-[30px] bg-[#008B39] text-white h-[47px] px-7 grid'>
                    <span className='my-auto'>Sign Up</span>
                </a>
                {/* <a href='https://yeboportal.web.app/'>Login</a>
                <a href='https://yeboportal.web.app/register' className='rounded-[30px] bg-[#008B39] text-white h-[47px] px-7 grid'>
                    <span className='my-auto'>Sign Up</span>
                </a> */}
            </div>
        </div>
        : null}
        </div>
    );
}

export default Header;